import React from 'react';
import Modal from '@omilia/modal';
import { Form, Field } from 'react-final-form';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';

import TextFieldFinalFormWrapper from 'components/TextFieldFinalFormWrapper';
import validate from './utils/formValidation';
import { Props } from './types';

const SForm = styled.form`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CreateNewEntityModal = ({
  onSubmit,
  onClose,
  onCheckEntityName,
}: Props) => (
  <Modal
    open
    shouldCloseOnBackdropClick
    shouldCloseOnEscPress
    glyph="entities"
    title="Create Entity"
    onClose={onClose}
  >
    <Form onSubmit={onSubmit}>
      {({ handleSubmit, invalid, submitting }) => (
        <SForm data-test="create-entity-modal" onSubmit={handleSubmit}>
          <Field
            component={TextFieldFinalFormWrapper}
            data-test="entity-name"
            label="Entity Name"
            name="entityName"
            placeholder="Please type a name for the entity"
            validate={value => validate(value, onCheckEntityName)}
          />
          <ButtonGroup>
            <Button
              color="secondary"
              data-test="cancel-button"
              variant="text"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              data-test="create-button"
              disabled={invalid}
              loading={submitting}
              type="submit"
              variant="contained"
            >
              Create
            </Button>
          </ButtonGroup>
        </SForm>
      )}
    </Form>
  </Modal>
);

export default CreateNewEntityModal;
